"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneRecursively = void 0;

var _react = require("react");

const cloneRecursively = (child, conditionFnc, renderFnc) => child && /*#__PURE__*/(0, _react.isValidElement)(child) ? recursivelyFindRealChildren({
  child,
  renderFnc,
  conditionFnc
}) : null;

exports.cloneRecursively = cloneRecursively;

const recursivelyFindRealChildren = _ref => {
  let {
    child,
    ...props
  } = _ref;
  // Extract props for local usage but remain in props to get passed forward
  const {
    conditionFnc,
    renderFnc
  } = props;

  if (conditionFnc(child)) {
    // Clone current layout element and continue traversing children
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      children: _react.Children.count(child.props.children) > 1 ? _react.Children.map(child.props.children, innerChild => recursivelyFindRealChildren({
        child: innerChild,
        ...props
      })) : recursivelyFindRealChildren({
        child: child.props.children,
        ...props
      })
    });
  } // Non-layout element found - recursion's bottom


  return renderFnc(child);
};